import { navCategories } from "@/mocks/homeNews";

export default function Footer() {
  return (
    <footer className="border-t border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <a href="#top" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-lg font-bold text-background-50 dark:text-foreground-950">
                71
              </span>
              <span className="font-heading text-lg font-black text-foreground-950">71吃瓜</span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-500">
              71吃瓜是热点速查入口：71吃瓜速报、71吃瓜快报与今日瓜田快讯随手可翻。最新动态、热门瓜事与网友讨论一站汇齐，拿起就能接着看。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <a href="#chat" aria-label="到瓜田热聊" className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full bg-secondary-100 text-foreground-600 transition hover:bg-primary-500 hover:text-background-50 dark:hover:text-foreground-950">
                <i className="ri-chat-heart-line" />
              </a>
              <a href="#top" aria-label="返回顶部" className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full bg-secondary-100 text-foreground-600 transition hover:bg-primary-500 hover:text-background-50 dark:hover:text-foreground-950">
                <i className="ri-arrow-up-line" />
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-heading text-sm font-bold text-foreground-950">栏目导航</h4>
            <ul className="mt-4 space-y-2.5">
              {navCategories.map((c) => (
                <li key={c}>
                  <a href={`#cat-${c}`} className="flex items-center gap-1.5 text-sm text-foreground-500 transition hover:text-primary-600">
                    <i className="ri-arrow-right-s-line text-foreground-300" /> {c}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-heading text-sm font-bold text-foreground-950">联系与反馈</h4>
            <p className="mt-4 text-sm leading-relaxed text-foreground-500">
              遇到新热点想提供线索，或对栏目有建议，欢迎给我们留言，编辑核实后尽快跟进。
            </p>
            <a href="mailto:hello@71chigua.cn" className="mt-3 inline-flex items-center gap-2 text-sm text-primary-600 transition hover:text-primary-700">
              <i className="ri-mail-line" /> hello@71chigua.cn
            </a>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-400">© 2026 71吃瓜 · 热点速查入口，仅供瓜友讨论参考。</p>
          <p className="text-xs text-foreground-400">
            <i className="ri-archive-line mr-1" /> 速报 · 快报 · 今日瓜田快讯
          </p>
        </div>
      </div>
    </footer>
  );
}